import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import moment from 'moment'
import {lowerCase} from "bootstrap-vue/esm/utils/string";
import Header from "../../components/Header.vue";
import {fetchYears} from "../../utils/fetchYears";
import YearComponent from "../../components/YearComponent.vue";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)


export default {
    components: {
        YearComponent,
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin
    },
    data: function() {
        return {
            pageTitle: "Liste des tresoreries",
            initialPage: parseInt(this.$route.query.page) > 0 ? parseInt(this.$route.query.page) : 1,
            filtre:{
                date_debut:'',
                date_fin:'',
                year: '',
            },
            dateOptions: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
            listYears: [],
            criteriacol:'',
            vuetable: {
                moreParams: {},
                fields: [
                    // {
                    //     name: VuetableFieldCheckbox,
                    //     titleClass: 'text-center',
                    //     dataClass: 'text-center'
                    // },
                    {
                        name: 'date_caution_formatted',
                        title: 'Date',
                        sortField: 'date_caution_formatted',
                        dataClass: 'text-left'
                    },


                    {
                        name: 'nom_client',
                        title: 'Client',
                        sortField: 'nom_client',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'ouverture_bl_numero',
                        title: 'N°BL',
                        sortField: 'ouverture_bl_numero',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'recu_payement_caution',
                        title: 'RECU PAYEMENT CAUTION',
                        sortField: 'recu_payement_caution',
                        dataClass: 'text-right'
                    },
                    {
                        name: 'ER_vide',
                        title: 'E|R vide',
                        sortField: 'ER_vide',
                        dataClass: 'text-left'
                    },{
                        name: 'date_restitution_conteneur_formatted',
                        title: 'Date restitution conteneur',
                        sortField: 'date_restitution_conteneur_formatted',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'chargmenet_quotient',
                        title: 'Montant',
                        sortField: 'chargmenet_quotient',
                        dataClass: 'text-right'
                    },
                    {
                        name: 'nom_compagnie_maritime',
                        title: 'COMPAGNIE',
                        sortField: 'nom_compagnie_maritime',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'ouverture_date_arriver_formatted',
                        title: 'DATE D\'ARRIVER DU NAVIRE',
                        sortField: 'ouverture_date_arriver_formatted',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'chargemnet_BAD',
                        title: 'BAD',
                        sortField: 'chargemnet_BAD',
                        dataClass: 'text-left',
                        width: '150px'
                    },
                    {
                        name: 'etat_et_date_de_demande_formatted',
                        title: 'ETAT DATE DE DEMANDE',
                        sortField: 'etat_et_date_de_demande_formatted',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'etat_payement',
                        title: 'ETAT DE PAYEMENT',
                        sortField: 'etat_payement',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'caution_deduite',
                        title: 'CAUTION DEDUITE',
                        sortField: 'caution_deduite',
                        dataClass: 'text-right'
                    },
                    {
                        name: 'montant_recu',
                        title: 'MONTANT RECU',
                        sortField: 'montant_recu',
                        dataClass: 'text-right'
                    },
                    {
                        name: 'commentaire',
                        title: 'COMMENTAIRE',
                        sortField: 'commentaire',
                        dataClass: 'text-left'
                    },
                    {
                        name: 'actions',
                        title: '-',
                        titleClass: 'text-center fixed-header',
                        width: "80px",
                        dataClass: "text-center fixed-td"
                    }

                ],
                sortOrder: [
                    { field: 'id', direction: 'desc' }
                ],
                css: {
                    table: {
                        // tableClass: 'table table-striped table-bordered table-hovered',
                        tableClass: 'table-responsive text-nowrap w-100 d-block d-md-table table table-bordered table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'fas fa-arrow-up fa-sm',
                        descendingIcon: 'fas fa-arrow-down fa-sm',
                        handleIcon: 'fas fa-bars fa-sm',
                    },
                    pagination: {
                        infoClass: 'pull-left ',
                        wrapperClass: 'vuetable-pagination text-center',
                        activeClass: 'btn-secondary',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        },
                    }
                },
            },
            exportexcel: {
                json_fields: {
                    'Nom de la Tresorerie': 'reference_article',
                    'Type de la Tresorerie': 'type_tresorerie',
                    'Solde': 'solde',
                    'Nom du compte': 'nom_compte',
                    'Numero du compte': 'numero_compte',
                    'BIC': 'bic',
                    'IBAN': 'iban',
                    'BANQUE Correspondante': 'banque_correspondante',
                    'Code swift': 'code_swift',
                    'Utilisateur associé': 'nom'

                },
                json_data: [],
                json_meta: [
                    [{
                        'key': 'charset',
                        'value': 'utf-8'
                    }]
                ],
            },
            motCle: "",
            crudform: {
                id: "",
                id_dossier:'',
                ouverture_bl_numero:'',
                chargmenet_quotient:'',
                nom_client:'',
                date_caution: moment().format('DD/MM/YYYY'),
                date_caution_formatted: moment().format('DD/MM/YYYY'),
                recu_payement_caution:'',
                ER_vide:'',
                etat_et_date_de_demande:'',
                etat_payement:'',
                caution_deduite:'',
                montant_recu:'',
                commentaire:'',
                date_restitution_conteneur:'',
                date_restitution_conteneur_formatted:'',
            },
            crudmodaltitle: "Nouveau Caution",
            btn_submit:false,
            DossierList:[],
            search_BL:'',
            tab_numeroBL:[],
            datepicker: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
            },
        }
    },
    methods: {
        selectBL(numero_bl){
            this.search_BL =numero_bl.text;
            this.crudform.ouverture_bl_numero = numero_bl.text;
            this.crudform.chargmenet_quotient = numero_bl.chargmenet_quotient;
            this.crudform.nom_client = numero_bl.nom_client;
            this.crudform.id_dossier = numero_bl.id;
            this.tab_numeroBL = [];

        },
        getNumeroBL(){
            let bl = this.search_BL;
            if (bl != ''){
                axios.get(this.BASE_URL+"/dossier/getnumerobl/"+bl).then((response)=>{
                    this.tab_numeroBL = response.data;
                })
            }

        },
        onRowClass(dataItem, index) {
            if (index == "") console.log("");
           /* return (dataItem.recu_payement_caution =='' || dataItem.recu_payement_caution == null )  ? 'bq_danger' :
                ( lowerCase(dataItem.recu_payement_caution) =='ok') ? 'bg_succes' : 'bg_warning';*/
            console.log(parseFloat(dataItem.caution_deduite) >0);
            console.log(parseFloat(dataItem.montant_recu) > 0);
            console.log('"---------------------')

            return  (dataItem.date_caution_formatted=='TOTAL') ?'bg-array' :
                    ((dataItem.etat_et_date_de_demande!= null) && (lowerCase(dataItem.etat_payement) =='deduction' || lowerCase(dataItem.etat_payement ) =='payer') ) ? 'bg_succes' :
                    ((dataItem.etat_et_date_de_demande!= null) && (lowerCase(dataItem.etat_payement) !=='deduction' || lowerCase(dataItem.etat_payement ) !=='payer') ) ?
                    'bq_danger' : '';
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.syncFiltersToUrl(paginationData.current_page);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        editRow(rowData) {
            //alert("You clicked edit on" + JSON.stringify(rowData))
            axios.get(this.BASE_URL + "/dossiercaution/get/" + rowData.id).then(response => {
                this.crudform = response.data[0];
                this.search_BL = this.crudform.ouverture_bl_numero;
            });
            this.crudmodaltitle = "Editer une caution";
            this.openModal();
        },
        deleteRow(rowData) {
            //alert("You clicked delete on" + JSON.stringify(rowData));
            var that = this;
            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment supprimer cette ligne?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Supprimer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        axios.post(that.BASE_URL + "/dossiercaution/delete/" + rowData.id).then(function(response) {
                            console.log(response);
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log(response.data.message);
                                that.setFilter();
                                Vue.$toast.open({
                                    message: response.data.message,
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                })

        },
        onLoading() {
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            console.log('loaded! .. hide your spinner here');
        },
        affiche_piece_jointe(nom_piece_jointe) {
            console.log(nom_piece_jointe);
            if ((nom_piece_jointe != '' && nom_piece_jointe != null)) {
                window.open(this.BASE_URL + "/upload/dossier/" + nom_piece_jointe, '_blank');
            }
        },
        applyFiltersToParams() {
            this.vuetable.moreParams.filter = this.motCle;
            this.vuetable.moreParams.criteriacol = this.criteriacol;
            this.vuetable.moreParams.filtre_etat = this.filtre_etat;
            this.vuetable.moreParams.year =  this.filtre.year;

            this.vuetable.moreParams.critere_date = (this.filtre.date_fin !="" || this.filtre.date_debut !="") ? "date_caution" : "";
            this.vuetable.moreParams.date_fin = (this.filtre.date_fin !="") ? this.filtre.date_fin : "";
            this.vuetable.moreParams.date_debut = (this.filtre.date_debut !="") ? this.filtre.date_debut : "";
        },
        syncFiltersToUrl(currentPage) {
            const query = {};
            if (this.motCle !== "") query.filter = this.motCle;
            if (this.criteriacol !== "") query.criteriacol = this.criteriacol;
            if (this.filtre.year !== "") query.year = this.filtre.year;
            if (this.filtre.date_debut !== "") query.date_debut = this.filtre.date_debut;
            if (this.filtre.date_fin !== "") query.date_fin = this.filtre.date_fin;
            if (parseInt(currentPage) > 1) query.page = String(currentPage);

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({ query }).catch(() => {});
            }
        },
        setFilter() {
            this.applyFiltersToParams();

            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        resetFilter() {
            this.motCle = "";
            this.criteriacol = "";
            this.filtre_etat = "";

            this.filtre={
                date_debut: '',
                date_fin:'',
                year: '',
            }
            this.setFilter();
        },
        onExport() {

            this.exportexcel.json_data = this.$refs.vuetable.$data.tableData;
            $("#excel-download").trigger("click");
        },
        openModal() {
            this.fetchData();
            this.$bvModal.show("crudmodal");
        },
        closeModal() {
            this.$bvModal.hide("crudmodal");
        },
        addRow() {
            this.search_BL ="";
            this.tab_numeroBL = [];
            this.crudmodaltitle = "Nouveau Caution";
            this.crudform = {
                id: "",
                id_dossier:'',
                ouverture_bl_numero:'',
                nom_client:'',
                date_caution: moment().format('DD/MM/YYYY'),
                date_caution_formatted: moment().format('DD/MM/YYYY'),
                recu_payement_caution:'',
                ER_vide:'',
                etat_et_date_de_demande:'',
                etat_payement:'',
                caution_deduite:'',
                montant_recu:'',
                commentaire:'',
                date_restitution_conteneur:'',
                date_restitution_conteneur_formatted:'',
            };
            // console.log(this.crudform);
            this.openModal();
        },
        onSubmit() {
            var that = this;

            this.$bvModal.msgBoxConfirm('Voulez-vous vraiment continuer l\'enregistrement?', {
                title: 'Confirmation',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Continuer',
                cancelTitle: 'Annuler',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    console.log(value);
                    if (value == true) {
                        var link = '';
                        that.btn_submit = true;

                        link = that.crudform.id == '' ? that.BASE_URL + "/dossiercaution/addaction" : that.BASE_URL + "/dossiercaution/editaction";

                        axios.post(link, $("#formulaire").serialize()).then(function(response) {
                            console.log(response);
                            that.btn_submit = false;
                            //this.message_reponse = response.data.msg;
                            if (response.data.error === "") {
                                console.log("Enregistrement effectué avec succès!");
                                that.closeModal();
                                that.setFilter();
                                Vue.$toast.open({
                                    message: 'Enregistrement effectué avec succès!',
                                    type: 'success',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            } else {
                                console.log("Erreur");
                                Vue.$toast.open({
                                    message: response.data.error,
                                    type: 'error',
                                    position: 'top-right'
                                    // all of other options may go here
                                });
                            }
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    // An error occurred
                });
        },
        fetchData: function() {
            axios.get(this.BASE_URL + "/tresoreries/fetchdata").then(response => {
                console.log(response)
                this.listdata = response.data;
            });
        },

        async fetchYear() {
            const response = await fetchYears({that: this, link: '/dossiercaution/fetchyear'})
            this.listYears = response.data;
        },
        selectYear(year){
            this.filtre.year = year;
            this.setFilter();
        },
    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        const query = this.$route.query;
        this.motCle = query.filter || "";
        this.criteriacol = query.criteriacol || "";
        this.filtre = {
            date_debut: query.date_debut || "",
            date_fin: query.date_fin || "",
            year: query.year || "",
        };
        this.applyFiltersToParams();
    },
    mounted: async function() {
        await this.fetchYear();
    }
}
